module.exports = __webpack_public_path__ + "media/images/email-fe5f67afe05f15c8e25684eca779e586.svg";